var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.84612 8.53846C7.31672 8.53846 6.07689 7.29864 6.07689 5.76923C6.07689 4.23983 7.31672 3 8.84612 3C10.3755 3 11.6154 4.23983 11.6154 5.76923C11.6154 7.29864 10.3755 8.53846 8.84612 8.53846ZM4.93534 11.3198C4.37441 11.5201 3.99997 12.0514 3.99997 12.6471V13.5578C3.99997 14.3799 4.72807 15.0114 5.54188 14.8951L6.20263 14.8007C7.95606 14.5502 9.73619 14.5502 11.4896 14.8007L12.1504 14.8951C12.9642 15.0114 13.6923 14.3799 13.6923 13.5578V12.6471C13.6923 12.0514 13.3178 11.5201 12.7569 11.3198C10.2279 10.4166 7.46431 10.4166 4.93534 11.3198Z",
    fill: "url(#paint0_linear_38_12606)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93534 11.3198L5.10998 11.8088H5.10998L4.93534 11.3198ZM5.54188 14.8951L5.61531 15.4091H5.61531L5.54188 14.8951ZM6.20263 14.8007L6.27606 15.3147H6.27606L6.20263 14.8007ZM11.4896 14.8007L11.4162 15.3147H11.4162L11.4896 14.8007ZM12.1504 14.8951L12.0769 15.4091H12.0769L12.1504 14.8951ZM12.7569 11.3198L12.5823 11.8088H12.5823L12.7569 11.3198ZM5.55766 5.76923C5.55766 7.5854 7.02996 9.05769 8.84612 9.05769V8.01923C7.60348 8.01923 6.59612 7.01187 6.59612 5.76923H5.55766ZM8.84612 2.48077C7.02996 2.48077 5.55766 3.95306 5.55766 5.76923H6.59612C6.59612 4.52659 7.60348 3.51923 8.84612 3.51923V2.48077ZM12.1346 5.76923C12.1346 3.95306 10.6623 2.48077 8.84612 2.48077V3.51923C10.0888 3.51923 11.0961 4.52659 11.0961 5.76923H12.1346ZM8.84612 9.05769C10.6623 9.05769 12.1346 7.5854 12.1346 5.76923H11.0961C11.0961 7.01187 10.0888 8.01923 8.84612 8.01923V9.05769ZM4.5192 12.6471C4.5192 12.2709 4.75569 11.9353 5.10998 11.8088L4.7607 10.8308C3.99312 11.1049 3.48074 11.832 3.48074 12.6471H4.5192ZM4.5192 13.5578V12.6471H3.48074V13.5578H4.5192ZM5.46845 14.3811C4.96744 14.4527 4.5192 14.0639 4.5192 13.5578H3.48074C3.48074 14.6959 4.4887 15.5701 5.61531 15.4091L5.46845 14.3811ZM6.1292 14.2867L5.46845 14.3811L5.61531 15.4091L6.27606 15.3147L6.1292 14.2867ZM11.563 14.2867C9.76091 14.0293 7.93133 14.0293 6.1292 14.2867L6.27606 15.3147C7.98078 15.0712 9.71146 15.0712 11.4162 15.3147L11.563 14.2867ZM12.2238 14.3811L11.563 14.2867L11.4162 15.3147L12.0769 15.4091L12.2238 14.3811ZM13.173 13.5578C13.173 14.0639 12.7248 14.4527 12.2238 14.3811L12.0769 15.4091C13.2035 15.5701 14.2115 14.6959 14.2115 13.5578H13.173ZM13.173 12.6471V13.5578H14.2115V12.6471H13.173ZM12.5823 11.8088C12.9366 11.9353 13.173 12.2709 13.173 12.6471H14.2115C14.2115 11.832 13.6991 11.1049 12.9315 10.8308L12.5823 11.8088ZM5.10998 11.8088C7.52601 10.9459 10.1662 10.9459 12.5823 11.8088L12.9315 10.8308C10.2896 9.88727 7.4026 9.88727 4.7607 10.8308L5.10998 11.8088Z",
    fill: "url(#paint1_linear_38_12606)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_38_12606",
    x1: 3.99997,
    y1: 8.95447,
    x2: 13.6923,
    y2: 8.95447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5B45F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_38_12606",
    x1: 3.99997,
    y1: 8.95447,
    x2: 13.6923,
    y2: 8.95447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5B45F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGold);
export default __webpack_public_path__ + "static/media/user-gold.1261543207aba35d0339c06016f4571b.svg";
export { ForwardRef as ReactComponent };